<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  viewBox="0 0 24 24"
>
  <path
    d="M15.6165 13.572C13.0373 12.9765 10.6357 12.4545 11.799 10.2585C15.3383 3.5745 12.7372 0 9 0C5.1885 0 2.65125 3.71175 6.201 10.2585C7.3995 12.4672 4.90725 12.9893 2.3835 13.572C0.14925 14.088 0 15.1793 0 17.0693L0.00375 18H1.5C1.5 15.6495 1.40625 15.3375 2.8785 14.9977C5.01675 14.505 7.03575 14.0393 7.77225 12.4058C8.0415 11.8095 8.21625 10.8285 7.51875 9.5445C5.97525 6.69525 5.58525 4.22775 6.4515 2.775C7.467 1.06875 10.521 1.077 11.5268 2.7495C12.3893 4.18275 12.006 6.66375 10.4745 9.5565C9.792 10.8457 9.97125 11.8237 10.242 12.417C10.9845 14.0422 13.0223 14.5125 15.18 15.0105C16.5893 15.3375 16.5 15.672 16.5 18H17.9963L18 17.0693C18 15.1793 17.8507 14.088 15.6165 13.572Z"
  />
</svg>
